var scope_0 = require('/opt/build/repo/example/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
var scope_1 = require('/opt/build/repo/example/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4be6d9395d132f7ecf078ba19596f7af.js').default;
var scope_2 = require('/opt/build/repo/example/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/61a8f08bea94f7c4703d3f9ede18412c.js').default;
var scope_3 = require('/opt/build/repo/example/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8873e5fa67fe27ecca3c4341831bfe3d.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    